module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('h4', [_vm._v("Search by keywords")]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "search-input--box",
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.loadResults($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "search-input--submit",
    on: {
      "click": _vm.loadResults
    }
  }, [_vm._v("Go")])]), _vm._v(" "), _c('div', {
    staticClass: "search-manufacturers"
  }, [_c('h4', [_vm._v("Search by manufacturer")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clickSearch),
      expression: "clickSearch"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.clickSearch = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.onClickResults(_vm.clickSearch)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select one")]), _vm._v(" "), _vm._l((_vm.manufacturers), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  })], 2), _vm._v(" "), (_vm.loading) ? _c('h2', [_vm._v("Searching...")]) : _vm._e(), _vm._v(" "), (_vm.results === 'empty') ? _c('h2', [_vm._v("No results to show")]) : _vm._e(), _vm._v(" "), (_vm.results && _vm.results !== 'empty') ? _c('h2', [_vm._v(_vm._s(_vm.results.length) + " Results:")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "search-results"
  }, _vm._l((_vm.results), function(result) {
    return _c('div', {
      staticClass: "search-results-result"
    }, [(result.img && !result.model) ? _c('lightbox', {
      key: result.img,
      attrs: {
        "src": _vm.api + result.img
      }
    }, [_c('img', {
      attrs: {
        "width": "300px",
        "src": _vm.api + result.img
      }
    })]) : _vm._e(), _vm._v(" "), (result.model) ? _c('lightbox', {
      key: result.model,
      staticClass: "search-results-result--model",
      attrs: {
        "src": _vm.api + result.model
      }
    }, [(result.model) ? _c('img', {
      attrs: {
        "width": "300px",
        "src": _vm.api + result.model
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h3', {
      staticClass: "search-results-result--title"
    }, [_vm._v(" " + _vm._s(result.title) + " ")]), _vm._v(" "), _c('h4', {
      staticClass: "search-results-result--desc"
    }, [_vm._v(" " + _vm._s(result.desc) + " ")])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c67f25e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 64
// module chunks = 1